
import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import Lottie from "react-lottie";
import animationData from "./Assets/lottie/lf30_editor_kZX3S3.json";

import logo from "./Assets/Images/logo1.png"

const PaymentCard = (props) => {
  const pathURL=props.location.search.split("?")[1]
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  
 
  useEffect(() => {
   
    // ${props.location.search.split("?")[1]}
    const langvar=''+pathURL.split("&")[0]
    const lang_scr = document.createElement("script");
    const scriptLang =  document.createTextNode(`  var wpwlOptions = {
      numberFormatting:false,
      locale:"${langvar}"
    };`)
    lang_scr.appendChild(scriptLang);
    const payment_scr = document.createElement("script");
    payment_scr.src = `https://oppwa.com/v1/paymentWidgets.js?checkoutId=${props.match.params.id}`;
    
    const parent = document.querySelector("body");
    parent.append(lang_scr);
    parent.append(payment_scr);

  }, [props.match.params.id === "SUCCESS"]);
  
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
    const visaType=pathURL.split("&")[1]
  return (
    <Container fluid as="section" className="payment-view">
      <Row>
       <Col xs="12" as="article" className="text-center my-3">       
          <img src={logo} alt="logo" style={{width:'15%'}}/>
        </Col>
        {props.match.params.id !== "SUCCESS" ? (
          <div className="col-12 text-center">
              <form 
              action={`https://www.myticketapp.co/payment/SUCCESS`} 
              class="paymentWidgets" 
              data-brands={"VISA MASTER"}>
              <Lottie options={defaultOptions} height={100} width={100} />
            </form>
          </div>
        ) : null}
      </Row>

    </Container>
  );
};

export default PaymentCard;
